import React, { useState, useEffect } from 'react';
import { PrimaryButton, DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
// Remove Pivot imports
// import { Pivot, PivotItem } from 'office-ui-fabric-react/lib/Pivot';
import { getCartState, ICartState } from '@msdyn365-commerce/global-state';
import { addCartLinesAsync } from '@msdyn365-commerce/retail-proxy/dist/DataActions/CartsDataActions.g';
import { getUrlSync } from '@msdyn365-commerce/core';
import { Accordion } from './Accordion'; // Adjust path as needed
import { CartLine } from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';
//import { getToleranceCodesAsync } from '../../actions/DataActionExtension.g';
import { Dropdown, Toggle } from 'office-ui-fabric-react';

interface SlitCoil {
    width: string;
    tolerance: string;
    quantity: string;
    innerDiameter: string;
    outerDiameter: string;
    maxCoilWeight: string;
    maxSkidWeight: string;
    innerDiameterTolerance: string; // Add ID tolerance
    outerDiameterTolerance: string;
    sameHeatLot: boolean;
}

interface SlitCoilPopupProps {
    isOpen: boolean;
    standardInnerDiameter: number;
    minInnerDiameter: number;
    maxInnerDiameter: number;
    standardOuterDiameter: number;
    minOuterDiameter: number;
    maxOuterDiameter: number;
    slitTolerance: string;
    productId: number;
    catalogId: number;
    productName?: string;
    minWidth?: number;
    maxWidth?: number;
    context: any;
    onDismiss: () => void;
}
interface CustomSlitError {
    width?: string;
    tolerance?: string;
    innerDiameter?: string;
    outerDiameter?: string;
    maxCoilWeight?: string;
    maxSkidWeight?: string;
    quantity?: string;
}

export interface SummaryRowsProps {
    slitCoils?: SlitCoil[];
    className?: string;
    isQuantityEditable?: boolean;
}
export const SummaryRows: React.FC<SummaryRowsProps> = ({ slitCoils, className, isQuantityEditable = true }) => {
    const renderSlitCoilRows = () => {
        if (!slitCoils || slitCoils.length === 0) {
            return null;
        }

        return slitCoils.map((coil, i) => (
            <div key={i} className='summary-row-grid'>
                {isQuantityEditable && (
                    <div className='summary-row-header'>
                        <strong>Coil #{i + 1}</strong>
                    </div>
                )}
                <div className={`summary-grid ${className || ''} `}>
                    {coil.width.trim() !== '' && <div className='summary-grid-item width'>Width: {coil.width}&quot;</div>}
                    <div className='summary-grid-item tolerance'>Tolerance: {coil.tolerance}</div>
                    {isQuantityEditable && <div className='summary-grid-item quantity'>Quantity: {coil.quantity}</div>}
                    <div className='summary-grid-item inner-diameter'>Inner Diameter: {coil.innerDiameter}&quot;</div>
                    {coil.innerDiameterTolerance && coil.innerDiameterTolerance.trim() !== '' && (
                        <div className='summary-grid-item id-tolerance'>ID Tolerance: {coil.innerDiameterTolerance}</div>
                    )}
                    <div className='summary-grid-item outer-diameter'>Outer Diameter: {coil.outerDiameter}&quot;</div>
                    {coil.outerDiameterTolerance && coil.outerDiameterTolerance.trim() !== '' && (
                        <div className='summary-grid-item od-tolerance'>OD Tolerance: {coil.outerDiameterTolerance}</div>
                    )}
                    {coil.maxCoilWeight.trim() !== '' && (
                        <div className='summary-grid-item max-coil-weight'>Max Coil Weight: {coil.maxCoilWeight} lbs</div>
                    )}
                    <div className='summary-grid-item max-skid-weight'>Max Skid Weight: {coil.maxSkidWeight} lbs</div>
                    <div className='summary-grid-item same-heat-lot'>Material from same heat lot: {coil.sameHeatLot ? 'Yes' : 'No'}</div>
                </div>
            </div>
        ));
    };
    return (
        <div className={`summary-rows-container ${className || ''}`}>
            <div className={`summary-content ${className || ''}`}>{renderSlitCoilRows()}</div>
        </div>
    );
};

const SlitCoilPopup: React.FC<SlitCoilPopupProps> = ({
    isOpen,
    standardInnerDiameter,
    minInnerDiameter,
    maxInnerDiameter,
    standardOuterDiameter,
    minOuterDiameter,
    maxOuterDiameter,
    slitTolerance,
    productId,
    catalogId,
    productName,
    context,
    minWidth,
    maxWidth,
    onDismiss
}) => {
    // State for tolerance codes
    const [toleranceCodes, setToleranceCodes] = useState<string[]>([]);
    const [error] = useState<string>('');
    const [open, setOpen] = useState(isOpen);
    //const [selectedAccordion, setSelectedAccordion] = useState(0);
    const [cart, setCart] = useState<ICartState | undefined>(undefined);
    const p = 0.5;

    React.useEffect(() => {
        const fetchCartState = async () => {
            const cartState = await getCartState(context.actionContext);
            setCart(cartState);
        };
        fetchCartState();
    }, []);
    const [slitCoils, setSlitCoils] = useState<SlitCoil[]>([
        {
            width: '',
            tolerance: slitTolerance,
            quantity: '',
            innerDiameter: standardInnerDiameter === undefined ? '' : standardInnerDiameter.toString(),
            outerDiameter: standardOuterDiameter === undefined ? '' : standardOuterDiameter.toString(),
            maxCoilWeight: '',
            maxSkidWeight: '',
            innerDiameterTolerance: slitTolerance,
            outerDiameterTolerance: slitTolerance,
            sameHeatLot: true
        }
    ]);

    const handleAddSlit = () => {
        setSlitCoils([
            ...slitCoils,
            {
                width: '',
                tolerance: slitTolerance,
                quantity: '',
                innerDiameter: standardInnerDiameter === undefined ? '' : standardInnerDiameter.toString(),
                outerDiameter: standardOuterDiameter === undefined ? '' : standardOuterDiameter.toString(),
                maxCoilWeight: '',
                maxSkidWeight: '',
                innerDiameterTolerance: slitTolerance,
                outerDiameterTolerance: slitTolerance,
                sameHeatLot: true
            }
        ]);
    };

    const handleRemoveSlit = (index: number) => {
        if (slitCoils.length <= 1) {
            return; // Don't allow removal of the last item
        }

        const updated = [...slitCoils];
        updated.splice(index, 1);
        setSlitCoils(updated);
    };
    const [errors, setErrors] = useState<CustomSlitError[]>([]);
    const calculateMaxCoilWeight = (innerDiameter: string, outerDiameter: string, width: string): string => {
        const id = parseFloat(innerDiameter);
        const od = parseFloat(outerDiameter);
        const w = parseFloat(width);
        if (!isNaN(id) && !isNaN(od) && !isNaN(w) && id > 0 && od > 0 && w > 0 && od > id) {
            const maxCoilWeight = p * (Math.PI / 4) * (od ** 2 - id ** 2) * w;
            return maxCoilWeight.toFixed(2);
        }
        return '';
    };
    const calculateOuterDiameter = (innerDiameter: string, maxCoilWeight: string, width: string): string => {
        const id = parseFloat(innerDiameter);
        const weight = parseFloat(maxCoilWeight);
        const w = parseFloat(width);

        if (!isNaN(id) && !isNaN(weight) && !isNaN(w) && id > 0 && weight > 0 && w > 0) {
            // Rearrange formula: weight = p * (π/4) * (od² - id²) * w
            // od² = (weight / (p * π/4 * w)) + id²
            const odSquared = weight / (p * (Math.PI / 4) * w) + id ** 2;
            if (odSquared > 0) {
                const od = Math.sqrt(odSquared);
                return od.toFixed(2);
            }
        }
        return '';
    };
    const handleChange = (index: number, field: keyof SlitCoil, value: string | undefined) => {
        const updated = [...slitCoils];
        if (field === 'sameHeatLot') {
            updated[index][field] = value === 'true';
        } else {
            updated[index][field] = value ?? '';
        }
        if (field === 'innerDiameter' || field === 'outerDiameter' || field === 'width') {
            updated[index].maxCoilWeight = calculateMaxCoilWeight(
                updated[index].innerDiameter,
                updated[index].outerDiameter,
                updated[index].width
            );
        } else if (field === 'maxCoilWeight') {
            // Calculate outer diameter when max coil weight changes
            const calculatedOD = calculateOuterDiameter(updated[index].innerDiameter, updated[index].maxCoilWeight, updated[index].width);
            if (calculatedOD) {
                updated[index].outerDiameter = calculatedOD;
            }
        }

        setSlitCoils(updated);
        const updatedErrors = [...errors];
        updatedErrors[index] = validateSlit(updated[index]);
        setErrors(updatedErrors);
    };
    const validateSlit = (slit: SlitCoil): CustomSlitError => {
        const error: CustomSlitError = {};

        // Width validation
        const wid = parseFloat(slit.width);
        if (!slit.width || slit.width.trim() === '' || isNaN(wid) || wid <= 0) {
            error.width = `Please enter a valid width.`;
        } else if ((minWidth && wid < minWidth) || (maxWidth && wid > maxWidth)) {
            const widthMinText = minWidth ? ` (${minWidth}" min` : '';
            const widthMaxText = maxWidth ? ` & ${maxWidth}" max` : '';
            const widthSuffix = minWidth || maxWidth ? ')' : '';
            error.width = `Width range ${widthMinText}${widthMaxText}${widthSuffix}.`;
        }

        // Tolerance validation
        if (!slit.tolerance || slit.tolerance.trim() === '') {
            error.tolerance = 'Please select a tolerance.';
        }

        // Inner Diameter validation
        const ID = parseFloat(slit.innerDiameter);
        if (!slit.innerDiameter || slit.innerDiameter.trim() === '' || isNaN(ID)) {
            error.innerDiameter = 'Please enter a valid inner diameter.';
        } else if ((minInnerDiameter && ID < minInnerDiameter) || (maxInnerDiameter && ID > maxInnerDiameter)) {
            const innerMinText = minInnerDiameter ? ` (${minInnerDiameter}" min` : '';
            const innerMaxText = maxInnerDiameter ? ` & ${maxInnerDiameter}" max` : '';
            const innerSuffix = minInnerDiameter || maxInnerDiameter ? ')' : '';
            error.innerDiameter = `ID range ${innerMinText}${innerMaxText}${innerSuffix}.`;
        }

        // Outer Diameter validation
        const OD = parseFloat(slit.outerDiameter);
        if (!slit.outerDiameter || slit.outerDiameter.trim() === '' || isNaN(OD)) {
            error.outerDiameter = 'Please enter a valid outer diameter.';
        } else if ((minOuterDiameter && OD < minOuterDiameter) || (maxOuterDiameter && OD > maxOuterDiameter)) {
            const outerMinText = minOuterDiameter ? ` (${minOuterDiameter}" min` : '';
            const outerMaxText = maxOuterDiameter ? ` & ${maxOuterDiameter}" max` : '';
            const outerSuffix = minOuterDiameter || maxOuterDiameter ? ')' : '';
            error.outerDiameter = `OD range ${outerMinText}${outerMaxText}${outerSuffix}.`;
        }

        // Max Coil Weight validation
        const maxCoilWeight = parseFloat(slit.maxCoilWeight);
        if (!slit.maxCoilWeight || slit.maxCoilWeight.trim() === '' || isNaN(maxCoilWeight) || maxCoilWeight <= 0) {
            error.maxCoilWeight = 'Please enter a valid max coil weight.';
        }

        // Max Skid Weight validation
        const maxSkidWeight = parseFloat(slit.maxSkidWeight);
        if (!slit.maxSkidWeight || slit.maxSkidWeight.trim() === '' || isNaN(maxSkidWeight) || maxSkidWeight <= 0) {
            error.maxSkidWeight = 'Please enter a valid max skid weight.';
        }

        // Quantity validation
        const qty = parseInt(slit.quantity, 10);
        if (!slit.quantity || slit.quantity.trim() === '' || isNaN(qty) || qty <= 0) {
            error.quantity = 'Please enter a valid quantity.';
        }

        return error;
    };
    const handleAddToCart = () => {
        const newErrors = slitCoils.map(validateSlit);
        setErrors(newErrors);
        // If any error exists, do not proceed
        if (
            newErrors.some(
                e => e.width || e.innerDiameter || e.tolerance || e.outerDiameter || e.maxCoilWeight || e.maxSkidWeight || e.quantity
            )
        ) {
            return;
        }
        const slitPropertiesArray = slitCoils.map(slit => ({
            Width: parseFloat(slit.width),
            WidthTolerance: slit.tolerance,
            InnerDiameter: parseFloat(slit.innerDiameter),
            InnerDiameterTolerance: slit.innerDiameterTolerance,
            OuterDiameter: parseFloat(slit.outerDiameter),
            OuterDiameterTolerance: slit.outerDiameterTolerance,
            MaxSkidWeight: parseFloat(slit.maxSkidWeight),
            MaxCoilWeight: parseFloat(slit.maxCoilWeight),
            Quantity: parseInt(slit.quantity, 10),
            SameHeatLot: slit.sameHeatLot
        }));
        const lines: CartLine[] = slitCoils.map((slit, index) => ({
            productId: productId,
            catalogId: catalogId,
            quantity: parseInt(slit.quantity, 10),
            Description: JSON.stringify({
                productName: productName,
                SlitProperties: slitPropertiesArray[index]
            }),
            EntryMethodTypeValue: 3,
            UnitOfMeasureSymbol: 'lb'
        }));
        addCartLinesAsync({ callerContext: context.actionContext }, cart?.cart?.Id || '', lines).then(() => {
            window.location.assign(getUrlSync('cart', context.actionContext)!);
            setOpen(false);
            onDismiss();
        });
    };
    const hasEnteredSlitData = () => {
        return slitCoils.some(
            coil =>
                coil.width.trim() !== '' ||
                coil.quantity.trim() !== '' ||
                coil.innerDiameter.trim() !== '' ||
                coil.outerDiameter.trim() !== '' ||
                coil.maxCoilWeight.trim() !== '' ||
                coil.maxSkidWeight.trim() !== ''
        );
    };
    const showSlitUnsavedChangesAlert = () => {
        if (hasEnteredSlitData()) {
            return window.confirm(
                'You have unsaved changes. Clicking OK will discard your custom slit coil configuration. Click Cancel to continue editing.'
            );
        }
        return true;
    };
    // Fetch tolerance codes when component mounts
    useEffect(() => {
        const fetchToleranceCodes = async () => {
            const toleranceCodes = ['±0.005', '±0.010', '±0.015', '±0.020', '±0.025', '±0.030', '±0.040', '±0.050'];
            setToleranceCodes(toleranceCodes);
            /*try {
                const result = await getToleranceCodesAsync({ callerContext: context.actionContext });
                // Fix: Access ToleranceCodes directly from result
                if (result && result.ToleranceCodes) {
                    setToleranceCodes(result.ToleranceCodes.map((tc: any) => tc.ToleranceCode || tc));
                } else {
                    setError('No tolerance codes available');
                }
            } catch (err) {
                setError('Failed to load tolerance codes');
            }*/
        };

        if (isOpen && context) {
            fetchToleranceCodes();
        }
    }, [isOpen, context]);
    // Handle tolerance selection
    const handleToleranceChange = (index: number, selectedTolerance: string) => {
        const updatedCoils = [...slitCoils];
        updatedCoils[index].tolerance = selectedTolerance;
        setSlitCoils(updatedCoils);
        // Clear tolerance error when selection is made
        const updatedErrors = [...errors];
        updatedErrors[index] = { ...updatedErrors[index], tolerance: undefined };
        setErrors(updatedErrors);
    };
    // Handle inner diameter tolerance selection
    const handleInnerDiameterToleranceChange = (index: number, selectedTolerance: string) => {
        const updatedCoils = [...slitCoils];
        updatedCoils[index].innerDiameterTolerance = selectedTolerance;
        setSlitCoils(updatedCoils);
    };

    // Handle outer diameter tolerance selection
    const handleOuterDiameterToleranceChange = (index: number, selectedTolerance: string) => {
        const updatedCoils = [...slitCoils];
        updatedCoils[index].outerDiameterTolerance = selectedTolerance;
        setSlitCoils(updatedCoils);
    };
    return (
        <>
            <div className='custom-slit-popup-root' style={open ? { display: 'block' } : { display: 'none' }}>
                <div className='custom-slit-popup-header'>
                    <h2 className='custom-slit-popup-title'>Custom Slit Coils for {productName || 'Product'}</h2>
                    <p className='custom-slit-popup-description'>Please specify your custom slit coil requirements below.</p>
                    <button
                        className='custom-slit-popup-close-btn'
                        aria-label='Close'
                        style={{
                            position: 'absolute',
                            top: 16,
                            right: 16,
                            background: 'transparent',
                            border: 'none',
                            fontSize: 24,
                            cursor: 'pointer',
                            lineHeight: 1
                        }}
                        onClick={() => {
                            if (showSlitUnsavedChangesAlert()) {
                                setOpen(false);
                                onDismiss();
                            }
                            //onDismiss();
                        }}
                    >
                        ×
                    </button>
                </div>
                <Accordion header='Slit Coil Properties' isOpen={true}>
                    <Stack tokens={{ childrenGap: 20 }}>
                        {/* Slit Coil Properties Section */}
                        <Stack tokens={{ childrenGap: 10 }}>
                            {slitCoils.map((coil, i) => (
                                <Stack key={i} className='custom-slit-coil-row'>
                                    <div className='custom-slit-coil-row-label'>{`#Coil ${i + 1}`}</div>
                                    <Stack horizontal tokens={{ childrenGap: 10 }}>
                                        <TextField
                                            className='custom-slit-coil-width'
                                            label={`Width${minWidth ? `(${minWidth}\" min` : ''}
                                                    ${maxWidth ? ` & ${maxWidth}\" max` : ''}
                                                    ${minWidth || maxWidth ? ')' : ''}`}
                                            placeholder='Slit Width in inches'
                                            value={coil.width}
                                            type='number'
                                            step='1'
                                            pattern='[0-9]*'
                                            onChange={(_, v) => {
                                                // Only allow integer values (digits only)
                                                if ((v ?? '') === '' || /^\d+$/.test(v ?? '')) {
                                                    handleChange(i, 'width', v);
                                                }
                                            }}
                                            onKeyDown={e => {
                                                // Prevent non-numeric characters
                                                if (e.key === '.' || e.key === '-' || e.key === 'e' || e.key === 'E' || e.key === '+') {
                                                    e.preventDefault();
                                                }
                                            }}
                                            errorMessage={errors[i]?.width}
                                        />
                                        <div className='custom-slit-coil-tolerance-container'>
                                            <label>Tolerance</label>
                                            {error ? (
                                                <div style={{ color: 'red' }}>Error: {error}</div>
                                            ) : (
                                                <Dropdown
                                                    className='custom-slit-coil-tolerance-dropdown'
                                                    placeholder='Select Tolerance'
                                                    label=''
                                                    options={toleranceCodes.map(tolerance => ({
                                                        key: tolerance,
                                                        text: tolerance
                                                    }))}
                                                    selectedKey={coil.tolerance}
                                                    onChange={(_, option) => handleToleranceChange(i, option?.key as string)}
                                                    errorMessage={errors[i]?.tolerance}
                                                />
                                            )}
                                        </div>
                                    </Stack>
                                    <Stack className='custom-slit-coil-container' horizontal tokens={{ childrenGap: 10 }}>
                                        <div className='custom-slit-coil-inner-outer-diameter-container'>
                                            <TextField
                                                className='custom-slit-coil-inner-diameter'
                                                label={`Inner Diameter${minInnerDiameter ? `(${minInnerDiameter}\" min` : ''}
                                                    ${maxInnerDiameter ? ` & ${maxInnerDiameter}\" max` : ''}
                                                    ${minInnerDiameter || maxInnerDiameter ? ')' : ''}`}
                                                placeholder={
                                                    minInnerDiameter && maxInnerDiameter
                                                        ? `Min: ${minInnerDiameter}\", Max: ${maxInnerDiameter}\"`
                                                        : minInnerDiameter
                                                        ? `Min: ${minInnerDiameter}\"`
                                                        : maxInnerDiameter
                                                        ? `Max: ${maxInnerDiameter}\"`
                                                        : 'Inner Diameter in inches'
                                                }
                                                value={coil.innerDiameter}
                                                type='text'
                                                onChange={(_, v) => {
                                                    // Only allow integer values (digits only)
                                                    if ((v ?? '') === '' || /^\d+$/.test(v ?? '')) {
                                                        handleChange(i, 'innerDiameter', v);
                                                    }
                                                }}
                                                onKeyDown={e => {
                                                    // Prevent non-numeric characters
                                                    if (e.key === '.' || e.key === '-' || e.key === 'e' || e.key === 'E' || e.key === '+') {
                                                        e.preventDefault();
                                                    }
                                                }}
                                                errorMessage={errors[i]?.innerDiameter}
                                            />
                                            <div className='custom-slit-coil-id-tolerance-container'>
                                                <label>ID Tolerance</label>
                                                {error ? (
                                                    <div style={{ color: 'red' }}>Error: {error}</div>
                                                ) : (
                                                    <Dropdown
                                                        className='custom-slit-coil-id-tolerance-dropdown'
                                                        placeholder='Select ID Tolerance'
                                                        label=''
                                                        options={toleranceCodes.map(tolerance => ({
                                                            key: tolerance,
                                                            text: tolerance
                                                        }))}
                                                        selectedKey={coil.innerDiameterTolerance}
                                                        onChange={(_, option) =>
                                                            handleInnerDiameterToleranceChange(i, option?.key as string)
                                                        }
                                                    />
                                                )}
                                            </div>
                                            <TextField
                                                className='custom-slit-coil-outer-diameter'
                                                label={`Outer Diameter${minOuterDiameter ? `(${minOuterDiameter}\" min` : ''}
                                                    ${maxOuterDiameter ? ` & ${maxOuterDiameter}\" max` : ''}
                                                    ${minOuterDiameter || maxOuterDiameter ? ')' : ''}`}
                                                placeholder={
                                                    minOuterDiameter && maxOuterDiameter
                                                        ? `Min: ${minOuterDiameter}\", Max: ${maxOuterDiameter}\"`
                                                        : minOuterDiameter
                                                        ? `Min: ${minOuterDiameter}\"`
                                                        : maxOuterDiameter
                                                        ? `Max: ${maxOuterDiameter}\"`
                                                        : 'Outer Diameter in inches'
                                                }
                                                value={coil.outerDiameter}
                                                type='text'
                                                onChange={(_, v) => {
                                                    // Only allow integer values (digits only)
                                                    if ((v ?? '') === '' || /^\d+$/.test(v ?? '')) {
                                                        handleChange(i, 'outerDiameter', v);
                                                    }
                                                }}
                                                onKeyDown={e => {
                                                    // Prevent non-numeric characters
                                                    if (e.key === '.' || e.key === '-' || e.key === 'e' || e.key === 'E' || e.key === '+') {
                                                        e.preventDefault();
                                                    }
                                                }}
                                                errorMessage={errors[i]?.outerDiameter}
                                            />
                                            <div className='custom-slit-coil-od-tolerance-container'>
                                                <label>OD Tolerance</label>
                                                {error ? (
                                                    <div style={{ color: 'red' }}>Error: {error}</div>
                                                ) : (
                                                    <Dropdown
                                                        className='custom-slit-coil-od-tolerance-dropdown'
                                                        placeholder='Select OD Tolerance'
                                                        label=''
                                                        options={toleranceCodes.map(tolerance => ({
                                                            key: tolerance,
                                                            text: tolerance
                                                        }))}
                                                        selectedKey={coil.outerDiameterTolerance}
                                                        onChange={(_, option) =>
                                                            handleOuterDiameterToleranceChange(i, option?.key as string)
                                                        }
                                                    />
                                                )}
                                            </div>
                                        </div>
                                        <div className='custom-slit-same-heat-lot'>
                                            <Toggle
                                                label='Material must be from the same heat lot'
                                                checked={coil.sameHeatLot}
                                                onChange={(_, checked) => handleChange(i, 'sameHeatLot', (checked ?? true).toString())}
                                            />
                                        </div>
                                        <div className='custom-slit-coil-weight-container'>
                                            <TextField
                                                className='custom-slit-coil-max-coil-weight'
                                                label='Max Coil Weight (lbs)'
                                                placeholder='Max Coil Weight in lbs'
                                                value={coil.maxCoilWeight}
                                                type='number'
                                                step='0.01'
                                                min='0'
                                                onChange={(_, v) => {
                                                    // Allow decimal values (digits and one decimal point)
                                                    if ((v ?? '') === '' || /^\d*\.?\d*$/.test(v ?? '')) {
                                                        handleChange(i, 'maxCoilWeight', v);
                                                    }
                                                }}
                                                onKeyDown={e => {
                                                    // Prevent multiple decimal points and negative signs
                                                    if (e.key === '-' || e.key === 'e' || e.key === 'E' || e.key === '+') {
                                                        e.preventDefault();
                                                    }
                                                    // Prevent multiple decimal points
                                                    if (e.key === '.' && coil.maxCoilWeight.includes('.')) {
                                                        e.preventDefault();
                                                    }
                                                }}
                                                errorMessage={errors[i]?.maxCoilWeight}
                                            />
                                            <TextField
                                                className='custom-slit-coil-max-skid-weight'
                                                label='Max Skid Weight (lbs)'
                                                placeholder='Max Skid Weight in lbs'
                                                value={coil.maxSkidWeight}
                                                type='number'
                                                step='0.01'
                                                min='0'
                                                onChange={(_, v) => {
                                                    // Allow decimal values (digits and one decimal point)
                                                    if ((v ?? '') === '' || /^\d*\.?\d*$/.test(v ?? '')) {
                                                        handleChange(i, 'maxSkidWeight', v);
                                                    }
                                                }}
                                                onKeyDown={e => {
                                                    // Prevent multiple decimal points and negative signs
                                                    if (e.key === '-' || e.key === 'e' || e.key === 'E' || e.key === '+') {
                                                        e.preventDefault();
                                                    }
                                                    // Prevent multiple decimal points
                                                    if (e.key === '.' && coil.maxSkidWeight.includes('.')) {
                                                        e.preventDefault();
                                                    }
                                                }}
                                                errorMessage={errors[i]?.maxSkidWeight}
                                            />
                                        </div>
                                        <div className='custom-slit-coil-quantity-remove-container'>
                                            <TextField
                                                className='custom-slit-coil-quantity'
                                                label='Quantity (lbs)'
                                                placeholder='Quantity'
                                                type='number'
                                                step='1'
                                                pattern='[0-9]*'
                                                value={coil.quantity}
                                                onChange={(_, v) => handleChange(i, 'quantity', v)}
                                                errorMessage={errors[i]?.quantity}
                                            />
                                            <DefaultButton
                                                className='remove-slit-coil-btn custom-slit-coil-remove-btn'
                                                text='Remove'
                                                disabled={slitCoils.length <= 1}
                                                ariaLabel='Remove slit coil'
                                                onClick={() => handleRemoveSlit(i)}
                                            />
                                        </div>
                                    </Stack>
                                </Stack>
                            ))}
                        </Stack>
                        <Stack horizontal tokens={{ childrenGap: 10 }} horizontalAlign='end'>
                            <DefaultButton className='custom-slit-coil-add-btn' text='+ Add Slit Coil' onClick={handleAddSlit} />
                            <PrimaryButton
                                className='custom-slit-coil-confirm-btn'
                                text='Add to Cart'
                                onClick={() => {
                                    // Only proceed to add to cart if validation passed
                                    if (
                                        errors.length > 0 &&
                                        errors.some(
                                            e =>
                                                e.width ||
                                                e.innerDiameter ||
                                                e.tolerance ||
                                                e.outerDiameter ||
                                                e.maxCoilWeight ||
                                                e.maxSkidWeight ||
                                                e.quantity
                                        )
                                    ) {
                                        return;
                                    }
                                    handleAddToCart();
                                }}
                            />
                            <DefaultButton
                                className='custom-slit-coil-cancel-btn'
                                text='Cancel'
                                onClick={() => {
                                    if (showSlitUnsavedChangesAlert()) {
                                        setOpen(false);
                                        onDismiss();
                                    }
                                }}
                            />
                        </Stack>
                    </Stack>
                </Accordion>
                {/*
                    <Accordion header='Summary' isOpen={selectedAccordion === 1} onHeaderClick={() => setSelectedAccordion(1)}>
                        <Stack tokens={{ childrenGap: 10 }}>
                            <h2 className='summary-title'>Slit Coil Summary</h2>
                            <SummaryRows slitCoils={slitCoils} className='Slit Popup summary' isQuantityEditable={true} />
                        </Stack>
                        <Stack horizontal tokens={{ childrenGap: 10 }} horizontalAlign='end'>
                            <PrimaryButton className='custom-slit-coil-add-to-cart-btn' text='Add to Cart' onClick={handleAddToCart} />
                            <DefaultButton
                                className='custom-slit-coil-cancel-btn'
                                text='Cancel'
                                onClick={() => {
                                    if (showSlitUnsavedChangesAlert()) {
                                        setOpen(false);
                                        onDismiss();
                                    }
                                }}
                            />
                        </Stack>
                    </Accordion>
                    */}
            </div>
        </>
    );
};

export default SlitCoilPopup;
